<template>
     <div ref="dom">
    </div>
</template>

<script>
import echarts from 'echarts'
import { on, off } from '@/libs/tools'
export default {
  name: 'DeployTrend',
  props: ['xData', 'yData'],
  data () {
    return {
      dom: null,
      xDataOwn: [],
      yDataOwn: [],
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          top: '3%',
          left: '1.2%',
          right: '1%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.xDataOwn
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '发布次数',
            type: 'line',
            stack: '总量',
            areaStyle: {normal: {
              color: '#2d8cf0'
            }},
            data: this.yDataOwn
          }
        ]
      }
    }
  },
  watch: {
    xData () {
      this.xDataOwn = this.xData
      this.option['xAxis'][0].data = this.xDataOwn
      this.init()
    },
    yData () {
      this.yDataOwn = this.yData
      this.option['series'][0].data = this.yDataOwn
      this.init()
    }
  },
  methods: {
    resize () {
      this.dom.resize()
    },
    init () {
      this.$nextTick(() => {
        this.dom = echarts.init(this.$refs.dom)
        this.dom.setOption(this.option)
        on(window, 'resize', this.resize)
      })
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  }
}
</script>
